import './styles/main.scss';
import stickyNav from './scripts/stickyNav.js';
import contacModal from './scripts/modal';
import videoPlayer from './scripts/videoPlayer';
import mobileMenu from './scripts/mobileMenu';
import footer from './scripts/footer';
import lazyLoading from './scripts/lazyLoading';
import formSubmit from './scripts/formSubmit';
